<template>
  <span v-if="session.foreigner" class="badge bg-info-soft"
    ><i class="fa-solid fa-clock me-1"></i>
    <span v-if="icon">
      {{ languages["pt-br"].flag }}
    </span>
    <span v-else>Horário de Brasília</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useMainStore } from "../store";
import { languages } from "../utils/languages";

const session = computed(() => useMainStore().session);

const { icon } = defineProps<{ icon?: boolean }>();
</script>
